module.exports = __webpack_public_path__ + "img/消防管理.ae203b82.svg";